"use client"; 

import { useState } from 'react'
import { PlusIcon, CheckIcon, CheckCircleIcon } from '@heroicons/react/20/solid'
import { BookmarkIcon } from '@heroicons/react/24/outline';

// import useSWR, { mutate } from 'swr'
// import axios from 'axios'

import SignUpModal from '../generic/signupModal';


import { classNames } from '../../../lib/helpers'
import { appWebsiteLink } from '../../../lib/helpers';

export default function AppFollowButtonGroup({ app={},  }) {

  // Early Access Modal 
  const [open, setOpen] = useState(false)  

  // // Getting apps, followed by current user
  // const userAppsUrl = `/api/users/apps`
  // const { data: userApps=[], error: userAppsError } = useSWR([userAppsUrl])

  // // Session 
  // const { data: session, status } = useSession()
  // const isAuthenticated = status === "authenticated"
  const isAuthenticated = false 

  // // userApps
  // const userAppUrl = `/api/apps/${app?.slug}/follow`  // todo different api 
  // const { data: userApp={}, error: userAppError } = useSWR(isAuthenticated ? [userAppUrl] : null)
  // const isFollowing = userApp?.is_following || false


  const isFollowing = true

  const FollowIcon = isFollowing ? CheckIcon : PlusIcon

  const [followLoading, setFollowLoading] = useState(false)

  const onFollowButtonClick = () => {
    if (!isAuthenticated) {
      setOpen(!open)
    } else {
      // setFollowLoading(true)
      // const newIsFollowing = !isFollowing  // changing when clicking a button 
      // const method = (!newIsFollowing && !isUsing) ? 'delete' : 'post'  // if both unfollowed and unused then delete 
      // const data = (newIsFollowing || isUsing) ? { is_following: newIsFollowing, is_using: isUsing } : {} 

      // axios({
      //   method: method, 
      //   url: `/api/apps/${app?.slug}/follow`,
      //   data: data
      // }).then(response => {
      //   setFollowLoading(false)
      //   mutate([userAppUrl])
      //   // const userApp = response.data
      // }).catch((error) => {
      //   setFollowLoading(false)
      //   toast.error('Something went wrong!');
      // });
    }

  }

 

  return (
    <>
      <div className="mx-0  grid grid-cols-3 sm:flex gap-3">
        <button
          type="button"
          className="inline-flex items-center gap-x-2 rounded bg-transparent py-2.5 px-3.5 text-sm font-semibold text-gray-900 hover:text-crisp-500 ring-1 ring-inset ring-gray-300"
          onClick={() => { onFollowButtonClick() }}
        >
          <BookmarkIcon className="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
          Save
        </button>

        <button
          type="button"
          className="inline-flex items-center gap-x-1 rounded bg-white py-2.5 px-4 text-sm font-semibold text-gray-900 shadow-sm hover:ring-crisp-500 ring-1 ring-inset ring-gray-300"
          onClick={() => { onFollowButtonClick() }}
          disabled={followLoading}        
        >
          <FollowIcon className="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
          Follow
        </button>

        <a
          href={appWebsiteLink(app)}
          target="_bkank"
          className="rounded bg-crisp-600 py-2.5 px-3.5 text-sm font-semibold text-white shadow-sm hover:bg-crisp-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-crisp-600"
        >
          Visit <span className="hidden lg:inline">website</span>
          {` `}<span aria-hidden="true">&rarr;</span>
        </a>

      </div>
      <SignUpModal open={open} setOpen={setOpen} />
    </>
  )
  
}
